import {
    Datagrid,
    TextField,
    ListProps,
    DateField,
    TextInput,
    BooleanField,
    DateInput,
} from "react-admin";
import { CustomFileField } from "../components/CustomFIleField";
import { CustomList } from "../components/CustomList";
import { SubjectField } from "../components/SubjectField";
import { GoToDeliveriesButton } from "../components/GoToDeliveriesButton";
import { useOptionsResource } from "../shared/hooks/useOptionsResource";
import { initField, getDefaultListProps } from "../shared/utils";
import { ReferenceInputSubject } from "../components/reference-inputs/ReferenceInputSubject";
import {DeliveryField} from "../components/DeliveryField";

export const MissingSubjectList = (props: ListProps) => {
  const { data: options } = useOptionsResource("GET");
  const filters = options
    ? [
      <TextInput {...initField("id", options)} />,
      <TextInput {...initField("business_name", options)} />,
    ]
    : [];
  return options ? (
    <CustomList
      filters={filters}
      {...getDefaultListProps(props)}
      sort={{ field: "id", order: "DESC" }}
    >
      <Datagrid>
        <TextField {...initField("id", options)} />
        <TextField {...initField("business_name", options)} label={"Ragione sociale"}/>
          <DeliveryField deliverySource={"delivery"} />
          <TextField {...initField("delivery_object.receiver", options)} label={"Destinatario"}/>
          <TextField {...initField("customer_subject_object.id", options)} label={"ID Destinatario Ordine"}/>
          <TextField {...initField("customer_subject_object.business_name", options)} label={"Destinatario Ordine"}/>
      </Datagrid>
    </CustomList>
  ) : null;
};
